// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1b0vb","title":"AfterFrontImage_title__3NgNZ"};